import { Component, OnInit, ViewChild } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { DialogComponent } from '../dialog/dialog.component';
import { UserActivityPage } from "./user-activity-datatable/user-activity-page";
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { UserActivityResultService } from './user-activity-datatable/userActivityResultService'
import { HttpService } from '../shared/services/http.service';
import { APPCONFIG } from '../config';
import { SessionHandler } from '../shared/services/session-handler.service';
import { CommonService } from '../shared/services/common.service';
import { DatePipe } from '@angular/common';

@Component({

    template: require('./user-activity.logs.component.html'),
    styles: [require('./user-activity.logs.component.scss'), require('../../app/newCommon.scss')],
    providers: [DatePipe]

})

export class userActivityLogs implements OnInit {
    @ViewChild(DatatableComponent) table: DatatableComponent;
    page = new UserActivityPage();
    filters: any = {};
    tableRows: any = [];
    userDetails: any;
    isSystemAdmin: boolean = false;
    isApplicationManager: boolean = false;
    isBUManager: boolean = false;
    isRegionalAdmin: boolean = false;
    isServiceOwner: boolean = false;
    isTradePartner: boolean = false;
    isSubUser: boolean = false;
    showTable: boolean = true;
    todaySelected: Date = new Date;
    Wpass: Array<any> = [];
    autocompleteLoader: string = "";
    searchWpass:string = "";
    selectedDate;
    today: Date = new Date();
    public model: any = { date: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() } };
    response = {};
    showCheckbox;
    selected = [];
    selectedStatusId: string = '';
    selectedCount: any;
    searchValue;


    constructor(private serverResultsService: UserActivityResultService, private sessionHandler: SessionHandler,
        private httpService: HttpService, private datePipe: DatePipe, private commonService: CommonService) {

        this.selectedDate = this.datePipe.transform(this.todaySelected, 'yyyy-MM-dd');
        //Close Sidebar Initially
        APPCONFIG.navCollapsed = true;

        this.page.pageNumber = 0;
        this.page.size = 20;

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isSystemAdmin) {
            this.getApplicationsList(this.filters)
        } else {
            this.showTable = false;
        }

        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.applicationDashboard.subscribe((value) => {
            this.getApplicationsList(this.filters);
        });
    }

    public myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'yyyy-mm-dd',
    };

    autocompleteSearch(term: string, filter: string) {

        if (filter == "wpass") {
            this.Wpass = [];
            this.searchWpass = term;
        }

        if (term == "") return;

        let url = "/lookupDataOperationsApi/v1/partialSearch?type=" + filter + "&searchStr=" + term;
        this.autocompleteLoader = filter;
        this.httpService.getRequestForAutocomplete(url).subscribe(
            res => {
                if (res && res['items']) {
                    let name = res['items'];
                    let filterArray = [];

                    for (let index in name) {
                        filterArray.push(name[index]['name']);
                    }

                    if (filter == "wpass") {
                        this.Wpass = filterArray;
                    }
                }
                this.autocompleteLoader = "";
                this.httpService.onEnd();
            },
            err => {
                this.autocompleteLoader = "";
                this.httpService.onEnd();
            })
    }

    onSelectAutocomplete(value, textFlag) {
        if (textFlag == "wpass") {
            this.searchWpass = value;
        }
    }

    public search() {
        this.selected = [];
        this.selectedDate = "";
        this.filters['offSet'] = 0;

        if(this.model) {
            if (this.model.formatted) {
                this.selectedDate = this.model.formatted;
            }else {
                var date1 = this.model.date.year + "-" + this.model.date.month + "-" + this.model.date.day;
                this.selectedDate = this.datePipe.transform(date1, 'yyyy-MM-dd');
            }
        }

        if (this.searchWpass == undefined) {
            this.searchWpass = "";
        } else if(this.searchWpass != "" && this.Wpass.length > 0){
            if(this.checkAutocompleteWord(this.Wpass, this.searchWpass)){
                this.searchWpass = "";
            }
        }

        this.getApplicationsList(this.filters);
    }

    checkAutocompleteWord(objArray, searchValue){
        if(objArray.includes(searchValue)){
            return false;
        } else {
            return true;
        }
    }

    public resetSearch() {
        this.searchWpass = '';
        this.Wpass = [];
        this.searchValue = "";
        this.selectedDate = "";
        this.model = { date: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() } };
        this.search();
    }
    
    onSelect({ selected }) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
        this.selectedCount = this.selected.length;
    }

    public getApplicationsList(filter) {
        this.showCheckbox = true;

        this.httpService.getRequest("/userActivityLogsOperationApi/v1/userActivityLogList?limit=" + filter.limit + "&offset=" + filter.offSet + "&wpassId=" + this.searchWpass + "&date=" + this.selectedDate).subscribe(
            res => {
                this.saveApplicationsList(res, filter);

            },
            err => {
                this.httpService.onEnd();
            }
        );

    }

    public saveApplicationsList = function (res, filter) {

        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if (res && Object.keys(res).length > 0) {
                this.applicationsDashboardData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;
                this.count = res.count;
                this.totalCount = res.totalCount;

                if (this.applicationsDashboardData.list) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.applicationsDashboardData.list) {
                        this.rows[data] = {};
                        this.rows[data]['name'] = this.applicationsDashboardData.list[data]['name'];
                        this.rows[data]['username'] = this.applicationsDashboardData.list[data]['username'];
                        this.rows[data]['description'] = this.applicationsDashboardData.list[data]['description'];
                        this.rows[data]['email'] = this.applicationsDashboardData.list[data]['email'];
                        this.rows[data]['wpassId'] = this.applicationsDashboardData.list[data]['wpassId'];
                        this.rows[data]['createdAt'] = this.applicationsDashboardData.list[data]['createdAt'];
                        /* this.rows[data]['createdAt'] = this.datePipe.transform(this.applicationsDashboardData.list[data]['createdAt'], 'dd-MM-yyyy hh:mm:ss a'); */


                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else {
                    this.showTable = false;
                }

                let finalRows = [];
                for (let f in this.rows) {
                    if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                        finalRows.push(this.rows[f]);
                    }
                    if (f == 'offset') {
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if (f == 'totalCount') {
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                this.httpService.onEnd();
            }
        }
    }
    public setPage(pageInfo, rows, filter) {
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']) {
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;


                        this.getApplicationsList(this.filters);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }
    ngOnInit() { }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-activity-logs/user-activity.logs.component.ts